module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2GVrBF/images/cover.jpg?1684229399485",
      "alt": "This image is the cover for the book Kansas Forts & Bases"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Kansas Forts & Bases\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The relationship between Kansas and the science of war is ingrained, consistent and evident, yet it seems antithetical to the quiet, conservative farmer who is the quintessential image of the state. It is not. The same values created both, and both created Kansas. From early exploration of America, Bleeding Kansas, the Civil War and the Plains Indian wars to the world wars and the modern era, the forts and bases of the Sunflower State have been central to America's defense. Beginning with Fort de Cavagnial in 1744 through to the defunct fields of Cold War missile silos, historians Debra Goodrich Bisel and Michelle M. Martin provide a guide to the forts and posts throughout Kansas.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Debra Goodrich Bisel, Michelle M. Martin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Deb Goodrich Bisel is president of the Shawnee County Historical Society and co-president of the Civil War Roundtable of Eastern Kansas. A freelance journalist and historian, she has appeared on numerous documentaries, has spoken to hundreds of groups around the nation and is a frequent talk-radio guest.")]), _c('p'), _c('p', [_vm._v("Michelle M. Martin is a widely sought-after living history interpreter. She has taught history at Pittsburg State University, Baker University and Fort Scott Community College in Kansas and is currently on the faculty at Rogers State University. Martin is the Director/Historian of the Little House on the Prairie Museum near Independence, KS.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0